import DictionaryContainer from 'components/Dictionary/DictionaryContainer'
import DictionaryPresentation from 'components/Dictionary/DictionaryPresentation'
import DictionaryData from 'components/Dictionary/DictionaryData'

export default {
  Container: DictionaryContainer,
  Presentation: DictionaryPresentation,
  Data: DictionaryData,
}
